<template>
	<el-dialog :title="title" :visible.sync="mdVisible" append-to-body :destroy-on-close="true" @close="handleCancel"
		:closeOnClickModal="false" width="60%" top="0vh" custom-class="center-dialog" :lock-scroll="false"
		@touchmove.prevent>
		<div class="popMain">
			<!-- 标题 -->
			<div class="popMainTitle">
				<h1>金桥平台</h1>
				<p>
					本项目位于上海市浦东新区金桥出口加工区17B-06地块、北邻浙桥路、至新金桥路、西接17B-01、17B-05地块、东至金科路，拟新建一栋248.150m的超高层商务办公楼，成为未来金桥城市副中心区域的新地标。
				</p>
			</div>
			<!-- 内容 -->
			<div class="popMainItem">
				<!-- 查看报价 -->
				<div class="homeBtn">
					<a class="more-btn" @click="consultBtn">查看报价</a>
				</div>
				<div class="homeMainPC">
					<viewer style="padding: 0;">
						<img src="@/assets/img/pro-jq.png" />
					</viewer>
					<p>驾驶舱</p>
				</div>
			</div>
		</div>
		<!-- 引入咨询弹窗 -->
		<consultPop ref="consultPop"></consultPop>
	</el-dialog>
</template>

<script>
	import consultPop from '@/views/service/modules/consultPop.vue'
	export default {
		components: {
			consultPop
		},
		data() {
			return {
				mdVisible: false,
				title: "",
				srcList: []
			};
		},
		methods: {
			show() {
				this.mdVisible = true
				this.stopScroll()
			},
			close() {
				this.mdVisible = false
				this.canScroll()
			},
			handleCancel() {
				this.close()
			},
			consultBtn() {
				this.$refs.consultPop.show()
			},
			//禁止滚动
			stopScroll() {
				var mo = function (e) {
					e.preventDefault();
				};
				document.body.style.overflow = 'hidden';
				document.addEventListener("touchmove", mo, false); //禁止页面滑动
			},
			/***取消滑动限制***/
			canScroll() {
				var mo = function (e) {
					e.preventDefault();
				};
				document.body.style.overflow = ''; //出现滚动条
				document.removeEventListener("touchmove", mo, false);
			}
		},
	}
</script>

<style lang="scss">
	// 控制的dialog样式需要穿透到底层，所以这里不能写scoped属性
	// 如果不想影响全局，可以给el-dialog的父级定义一个class,再把.center-dialog置于这个class的嵌套里面
	.center-dialog {
		top: 50%;
		transform: translateY(-50%);
		border-radius: 10px;
	}

	.popMain {
		height: 60vh;
		overflow-y: auto;
		padding: 0 20px;

		.popMainTitle {
			h1 {
				font-size: 26px;
				margin-bottom: 20px;
				opacity: 0.95;
			}

			p {
				width: 100%;
				font-size: 16px;
				line-height: 28px;
				text-align: left;
				color: #333;
				opacity: 0.85;
			}
		}

		.popMainItem {
			margin-top: 30px;

			.homeMainPC {
				width: 100%;

				img {
					width: 100%;
					cursor: pointer;
				}

				p {
					text-align: center;
					margin-top: 5px;
					margin-bottom: 40px;
				}
			}
		}
	}

	.popMainItem .homeMainPC p:last-child {
		margin-bottom: 0;
	}

	/*滚动条样式*/
	.popMain::-webkit-scrollbar {
		width: 4.5px; //纵向滚动条的宽度
	}

	.popMain::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
		background: rgba(0, 0, 0, 0.08);
	}

	// .popMain::-webkit-scrollbar-track {
	// 	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
	// 	border-radius: 0;
	// 	background: rgba(0, 0, 0, 0.08);
	// }

	/*滚动条样式*/
	// homeBtn开始**********************
	.popMainItem .homeBtn {
		width: 100%;
		text-align: center;
		margin-bottom: 55px;
	}

	.more-btn {
		text-decoration: none;
		position: relative;
		display: inline-block;
		padding: 8px 25px;
		font-size: 14px;
		color: #fff;
		background-color: #409EFF;
		border-radius: 20px;
	}

	.popMainItem .more-btn::before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		border: 1.5px solid #409EFF;
		top: 50%;
		left: 50%;
		padding: 2px;
		transform: translate(-50%, -50%);
		border-radius: inherit;
		border-radius: 30px;
		-webkit-animation: actif-btn-wave 1s infinite ease-out;
		animation: actif-btn-wave 1s infinite ease-out;
	}

	.popMainItem .more-btn:hover {
		-webkit-animation: anim-moema-1 0.4s forwards;
		animation: anim-moema-1 0.4s forwards;
	}

	@keyframes actif-btn-wave {
		0% {
			-webkit-transform: translate(-50%, -50%) scale(1);
			transform: translate(-50%, -50%) scale(1);
			opacity: 1;
			-webkit-transform-origin: center;
			transform-origin: center;
		}

		100% {
			-webkit-transform: translate(-50%, -50%) scale(1.2);
			transform: translate(-50%, -50%) scale(1.2);
			opacity: 0;
			-webkit-transform-origin: center;
			transform-origin: center;
		}
	}

	@keyframes anim-moema-1 {
		60% {
			-webkit-transform: scale3d(0.8, 0.8, 1);
			transform: scale3d(0.8, 0.8, 1);
		}

		85% {
			-webkit-transform: scale3d(1.1, 1.1, 1);
			transform: scale3d(1.1, 1.1, 1);
		}

		100% {
			-webkit-transform: scale3d(1, 1, 1);
			transform: scale3d(1, 1, 1);
		}
	}

	// homeBtn结束**********************

	// 修改弹窗样式
	.center-dialog .el-dialog__header {
		padding: 0px;
	}

	.center-dialog .el-dialog__headerbtn {
		top: 18px;
		right: 18px;
	}

	.center-dialog .el-dialog__body {
		padding: 30px 10px;
		padding-top: 40px;
	}

	.center-dialog .el-dialog__headerbtn .el-dialog__close {
		font-weight: 600;
	}
</style>
<style>
	/deep/ .el-dialog__wrapper {
		overflow: hidden;
	}

	/deep/ .el-popup-parent--hidden {
		padding-right: 0 !important;
	}

	/* /deep/ .el-dialog {
		background: rgba(238, 241, 249, 0.96);
	} */
</style>
<style>
	body {
		padding-right: 0px !important;
	}

	.viewer-transition {
		z-index: 9999 !important;
	}

	.viewer-canvas {
		/* bottom: 0;
	left: 0;
	overflow: hidden;
	position: absolute;
	right: 0; */
		top: 61px !important;
		padding-top: 20px;
		/* background: pink; */
	}

	.viewer-canvas>img {
		margin-top: 0 !important;
	}

	.viewer-title,
	.viewer-navbar {
		display: none;
	}
</style>